import React, {useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';
import {SavedQueriesTable} from "./SavedQueriesTable";
import {FormikProps} from 'formik';
import styles from './styles.module.scss';

interface FormValues {
  query: string;
}

type FilterValues = {
  query: string;
  reportId: string;
};

type Props = {
  setFieldValue: FormikProps<FormValues>['setFieldValue'];
  applyFilter: (values: FilterValues) => void;
}

const PopupSelectSaved = ({setFieldValue, applyFilter}: Props) => {
  const {formatMessage} = useIntl();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  return (
    <>
      <Button
        className={'btn btn-sm custom-send-button p-1 w-40px h-40px mx-2'}
        onClick={handleShowModal}
      >
        <img src={toAbsoluteUrl('/media/svg/List-stars_white.svg')} alt="i" width={30}/>
      </Button>
      <Modal
        show={show}
        onHide={handleCloseModal}
        className="popupAddReceiptContainer"
      >
        <Modal.Body>
          <h3 className="card-title font-weight-bold text-dark text-center mb-1">
            {formatMessage({id: 'ai-reports-list-saved', defaultMessage: 'Saved queries'})}
          </h3>
          <SavedQueriesTable
            handleCloseModal={handleCloseModal}
            setFieldValue={setFieldValue}
            applyFilter={applyFilter}
          />
          <div className={styles.buttonsContainer}>
            <Button
              className="btn btn-secondary btn-sm w-100px mx-3"
              onClick={() => handleCloseModal()}
            >
              {formatMessage({id: 'button-cancel', defaultMessage: 'Cancel'})}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupSelectSaved;
